module.exports = __webpack_public_path__ + "static/wrkat-caseimg-c0a3a377b97f49daa46bb17d3954f141.jpg";